import './home.less';
import { useEffect, useState, useRef, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AddSubtitles from '@/assets/home/card/AddSubtitles.png';
import AddSubtitlesAction from '@/assets/home/card/AddSubtitles_action.png';
import AddNarration from '@/assets/home/card/AddNarration.png';
import AddNarrationAction from '@/assets/home/card/AddNarration_action.png';
import TranslateVideo from '@/assets/home/card/TranslateVideo.png';
import TranslateVideoAction from '@/assets/home/card/TranslateVideo_action.png';
import RewriteVideo from '@/assets/home/card/RewriteVideo.png';
import RewriteVideoAction from '@/assets/home/card/RewriteVideo_action.png';
import HomeImg from '@/assets/edit/addsubtitleempty.svg';
import { formatMilliseconds, timeDiffFromNow } from '@/utils/dayjs';
import Icon from '@/components/iconfont/Icon.jsx';
import { projectController } from '@/api';
import VideoRewrite from '@/components/videoRewrite/VideoRewrite';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import { useDashboardData } from '@/hooks/DashboardHooks.js';
import { CheckEquity } from '@/utils/CheckEquity.js';
import { useDrawer } from '@/hooks/DrawerHooks.js';
import { useDispatch, useSelector } from 'react-redux';
import { setProjectCount } from '@/store/slices/home.js';
import RcPagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import SurveySuccess from '@/components/SurveySuccess/SurveySuccess.jsx';
import { UploadContext } from '@/context/vidtranslate/UploadContext.jsx';
import { useTranslation } from 'react-i18next';
import i18n from '@/utils/i18n.ts';
import { useTranslate } from '@/hooks/TranslationHooks';
import Vidtranslate from '@/pages/vidtranslate/Vidtranslate.jsx';
export const DISCORD_URL = 'https://discord.com/invite/X9RQGpxGRf';
const STATES = {
  TRANSCRIBING: 1,
  EXPORTING: 3,
  TRANSLATING: 5,
};

function getStateText(state, useHeygen) {
  if (state === STATES.TRANSCRIBING || state === STATES.TRANSLATING) {
    return useHeygen ? i18n.t('As_Home_ProjectState3') : i18n.t('As_Home_ProjectState1');
  } else if (state === STATES.EXPORTING) {
    return i18n.t('As_Home_ProjectState2');
  }
}

export default function Home() {
  // const selectFlag = useSelectFlag();
  const [projectList, setProjectList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { needRefreshProjects, setChildCallback } = useDashboardData();
  const dispatch = useDispatch();
  const [pageInfo, setPageInfo] = useState({ pageIndex: 0, pageSize: 12, total: 0 });

  useEffect(() => {
    getList();
  }, [pageInfo?.pageIndex, pageInfo?.pageSize]);

  useWebSocket(
    'RETRY_SUCCESS',
    useCallback(() => {
      getList();
    }, []),
  );
  useEffect(() => {
    if (!needRefreshProjects) return;
    getList();
    setChildCallback(Date.now());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needRefreshProjects]);
  const setListData = (val) => {
    const obj = {
      duration: val.duration,
      gmtModified: '',
      id: val.tempId,
      name: val.name,
      state: 1,
      thumbnail: val.imgUrl,
      type: val.type,
      tempStatus: true,
      isHover: false,
    };
    pageInfo.total += 1;
    setPageInfo(pageInfo);
    if (projectList.length === 12) {
      setProjectList([obj, ...projectList.slice(0, -1)]);
    } else {
      setProjectList([obj, ...projectList]);
    }
  };
  const updateProjectId = (oldId, newId) => {
    setProjectList((prevList) =>
      prevList.map((project) =>
        project.id == oldId ? { ...project, tempStatus: false, id: newId } : project,
      ),
    );
  };
  const getList = async () => {
    setLoading(true);
    try {
      const res = await projectController.list({
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
      });
      if (res.code === 0) {
        // for (let index = 0; index < 1000; index++) {
        //   res.data.push(res.data[0]);
        // }
        res.data.rows ||
          [].filter((item) => {
            item.editShow = false;
          });
        setProjectList(res.data.rows);
        setPageInfo((page) => ({
          ...page,
          total: res.data?.totalRowCount || 0,
        }));
        dispatch(setProjectCount(res.data?.rows?.length || 0));
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useWebSocket(
    MessageEventType.PROJECT_CREATED,
    useCallback(
      ({ isSucceed, projectId, duration, projectName }) => {
        const updatedProjectList = projectList.map((project) => {
          if (project.id === projectId) {
            return {
              ...project,
              name: projectName,
              duration: duration,
              state: isSucceed ? 2 : 8,
            };
          }
          return project;
        });
        setProjectList(updatedProjectList);
      },
      [projectList],
    ),
  );
  useWebSocket(
    MessageEventType.EXPORT_SUCCESS,
    useCallback(
      ({ isSucceed, projectId, projectName }) => {
        if (isSucceed) {
          const updatedProjectList = projectList.map((project) => {
            if (project.id === projectId) {
              return {
                ...project,
                name: projectName,
                state: 4,
              };
            }
            return project;
          });
          setProjectList(updatedProjectList);
        }
      },
      [projectList],
    ),
  );

  return (
    <div className="home_box">
      {loading ? (
        <div className="loading_main">
          <span className="loading loading-spinner loading-md text-neutral"></span>
        </div>
      ) : (
        <>
          <HomeStarted
            projectList={projectList}
            setListData={setListData}
            updateProjectId={updateProjectId}
          />
          <HomeProjectList
            projectList={projectList}
            getList={getList}
            pageInfo={pageInfo}
            setPageInfo={setPageInfo}
          />
        </>
      )}
      <SurveySuccess></SurveySuccess>
    </div>
  );
}
function HomeStarted({ setListData, updateProjectId }) {
  const { setChildCallback, userData, userDetailSuccess } = useDashboardData();
  const { setVidtranslateModalShow, setShowAddSubtitles } = useContext(UploadContext);
  const projectCount = useSelector((state) => state.home.projectCount);
  // const navigate = useNavigate();
  const [showUpload, setShowUpload] = useState(false);
  const [projectType, setProjectType] = useState(0);
  const { t } = useTranslation();
  useEffect(() => {
    const tfrom = sessionStorage.getItem('tfrom');
    if (tfrom) {
      console.log(userData, 'userDatauserDatauserData');

      if (tfrom === 'trans') {
        if (userDetailSuccess > 0) {
          handleTranslate();
        }
      }
      if (tfrom === 'rewrite') {
        if (userDetailSuccess > 0) {
          handleAiRewrite();
        }
      }
      if (userDetailSuccess > 0) {
        setTimeout(() => {
          sessionStorage.removeItem('tfrom');
        }, 200);
      }
    }
  }, [userDetailSuccess]);
  // const handleToRecord = () => {
  //   // SentryTracker.captureEvent('homepage_main_record_click', userData?.userInfo?.email);
  //   window.onClickGATrackEvent('entry-video-message');
  //   if (!checkProjectPermissions()) {
  //     return;
  //   }
  //   if (reachProjectCountLimit()) {
  //     return;
  //   }
  //   navigate('/recording');
  // };
  const handleAiRewrite = (type = 0) => {
    // type: 0 重写 , 1 旁白
    // SentryTracker.captureEvent('homepage_main_upload_click', userData?.userInfo?.email);
    setChildCallback(Date.now());
    if (!checkProjectPermissions()) {
      return;
    }
    setShowUpload(true);
    setProjectType(type);
  };
  const handleTranslate = () => {
    // SentryTracker.captureEvent('homepage_main_upload_click', userData?.userInfo?.email);
    setChildCallback(Date.now());
    if (!checkProjectPermissions()) {
      return;
    }
    setVidtranslateModalShow(true);
  };

  const checkProjectPermissions = () => {
    if (!CheckEquity({ userData, type: 'freeCount', projectCount })) {
      setSubscribeTitle(t('As_Home_Limit1'));
      setSubscribeOptions({
        description: t('As_Home_Limit2'),
        confirmText: t('As_Home_Limit3'),
      });
      setIsSubscribeOpen('open');
      return false;
    }

    if (!CheckEquity({ userData, type: 'storage' })) {
      setSubscribeTitle('Your storage space has been used up');
      setIsSubscribeOpen('open');
      return false;
    }
    if (!CheckEquity({ userData, type: 'transcript' })) {
      setSubscribeTitle('Your AI Transcription has been used up');
      setIsSubscribeOpen('open');
      return false;
    }
    return true;
  };
  const { setIsSubscribeOpen, setSubscribeTitle, setSubscribeOptions } = useDrawer();

  return (
    <div className="home_img_content">
      <div className="title">{useTranslate('As_Edit_Welcome-greeting')}</div>
      <div className="img_box">
        <div
          className="img_left"
          onClick={() => {
            window.onClickGATrackEvent('entry-add-subtitles');
            setShowAddSubtitles(true);
            handleTranslate();
          }}>
          <img className="img_block default_card" src={AddSubtitles} alt="" />
          <img className="img_block active_card" src={AddSubtitlesAction} alt="" />
          <div className="title1">{t('As_Edit_Function3')}</div>
          <button className="btn btn-outline btn-primary">
            {/* {t('As_Home_Function2CTA')} */}
            {useTranslate('As_Edit_FunctionCTA2')}
            <Icon name="icon-arrow-right"></Icon>
          </button>
        </div>

        <div
          className="img_left"
          onClick={() => {
            window.onClickGATrackEvent('entry-add-narration');
            handleAiRewrite(1);
          }}>
          <img className="img_block default_card" src={AddNarration} alt="" />
          <img className="img_block active_card" src={AddNarrationAction} alt="" />
          <div className="title1">{t('As_Edit_Function4')}</div>
          <button className="btn btn-outline btn-primary">
            {/* {t('As_Home_Function3CTA')} */}
            {useTranslate('As_Edit_FunctionCTA3')}
            <Icon name="icon-arrow-right"></Icon>
          </button>
        </div>

        <div
          className="img_left"
          onClick={() => {
            window.onClickGATrackEvent('entry-video-translate');
            handleTranslate();
          }}>
          <img className="img_block default_card" src={TranslateVideo} alt="" />
          <img className="img_block active_card" src={TranslateVideoAction} alt="" />
          <div className="title1">{t('As_Edit_Function1')}</div>
          <button className="btn btn-outline btn-primary">
            {/* {t('As_Home_Function1CTA')} */}
            {useTranslate('As_Edit_FunctionCTA1')}
            <Icon name="icon-arrow-right"></Icon>
          </button>
        </div>

        <div
          className="img_left"
          onClick={() => {
            window.onClickGATrackEvent('entry-video-rewrite');
            handleAiRewrite();
          }}>
          <img className="img_block default_card" src={RewriteVideo} alt="" />
          <img className="img_block active_card" src={RewriteVideoAction} alt="" />
          <div className="title1">{t('As_Edit_Function2')}</div>
          <button className="btn btn-outline btn-primary">
            {/* {t('As_Home_Function3CTA')} */}
            {useTranslate('As_Edit_FunctionCTA3')}
            <Icon name="icon-arrow-right"></Icon>
          </button>
        </div>

        {/* <div className="img_left" onClick={handleToRecord}>
          <img className="img_block" src={Imgpic03} alt="" />
          <div className="title1">{t('As_Home_Function3T')}</div>
          <button className="btn btn-outline btn-primary">
            {t('As_Home_Function4CTA')}
            <Icon name="icon-arrow-right"></Icon>
          </button>
        </div> */}
      </div>

      <VideoRewrite
        show={showUpload}
        projectType={projectType}
        onClose={() => {
          setShowUpload(false);
        }}
        onUpload={(val) => {
          // getList();
          console.log('创建项目数据', val);
          setListData(val);
        }}
        onCreateSuccess={(val) => {
          updateProjectId(val.tempId, val.projectId);
          setChildCallback(Date.now());
        }}></VideoRewrite>
      <Vidtranslate
        onUpload={(val) => {
          console.log('创建项目数据', val);
          setListData(val);
        }}
        onCreateSuccess={(val) => {
          updateProjectId(val.tempId, val.projectId);
          setChildCallback(Date.now());
        }}
      />
    </div>
  );
}

function HomeProjectList({ projectList, getList, pageInfo, setPageInfo }) {
  // useEffect(() => {
  //   console.log(pageInfo, projectList, 'pageInfopageInfo');
  // }, [pageInfo]);
  const handlePagChange = (pageIndex, pageSize) => {
    setPageInfo((page) => ({
      ...page,
      pageIndex: pageIndex - 1,
      pageSize,
    }));
  };
  return (
    <div className="home_project_box">
      <div className="title">{useTranslate('As_Home_Checkuserproject')}</div>
      {projectList?.length > 0 ? (
        <div className="project_list">
          {projectList.map((item, index) => (
            <HomeProjectItem
              item={item}
              key={index}
              getList={getList}
              pageInfo={pageInfo}
              setPageInfo={setPageInfo}
            />
          ))}
        </div>
      ) : (
        <EmptyHome />
      )}
      {pageInfo?.total > 12 && (
        <div className="page_box">
          <RcPagination
            current={pageInfo?.pageIndex + 1}
            defaultPageSize={pageInfo?.pageSize}
            total={pageInfo?.total}
            align="center"
            onChange={handlePagChange}
            showTitle={false}
            prevIcon={
              <button className={`rc-flip ${pageInfo.pageIndex === 0 && 'rc-disabled-flip'}`} />
            }
            nextIcon={
              <button
                className={`rc-flip ${pageInfo.pageIndex + 1 === Math.ceil(pageInfo.total / pageInfo.pageSize) && 'rc-disabled-flip'}`}
              />
            }
          />
        </div>
      )}
    </div>
  );
}

function HomeProjectItem({ item, getList, pageInfo, setPageInfo }) {
  const [itemData, setItemData] = useState(JSON.parse(JSON.stringify(item)));
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const { setChildCallback } = useDashboardData();
  useEffect(() => {
    if (itemData.editShow && inputRef.current) {
      inputRef.current.focus();
    }
  }, [itemData.editShow]);
  useEffect(() => {
    setItemData(JSON.parse(JSON.stringify(item)));
  }, [item]);
  const handleChangeName = (e) => {
    itemData.name = e.target.value;
    item.name = e.target.value;
    setItemData(JSON.parse(JSON.stringify(itemData)));
  };

  const handleEditEnd = () => {
    itemData.editShow = false;
    setItemData(JSON.parse(JSON.stringify(itemData)));
    item.editShow = false;
    if (!itemData.name) {
      getList();
      return;
    }
    projectController.rename({
      projectId: itemData.id,
      body: {
        projectName: itemData.name,
      },
    });
  };

  const handleEditName = () => {
    itemData.editShow = true;
    setItemData(JSON.parse(JSON.stringify(itemData)));
    item.editShow = true;
    // setProjectList((prevList) =>
    //   prevList.map((project) =>
    //     project.id == itemData.id ? { ...project, editShow: true } : project,
    //   ),
    // );
    mouseLeaveClose();
  };
  const mouseLeaveClose = () => {
    itemData.isOpen = false;
    itemData.isHover = false;
    setItemData(JSON.parse(JSON.stringify(itemData)));
    // setProjectList((prevList) =>
    //   prevList.map((project) =>
    //     project.id == itemData.id ? { ...project, isHover: false } : project,
    //   ),
    // );
    item.isHover = false;
  };
  const mouseHoverShow = () => {
    if (itemData.tempStatus) {
      // setProjectList((prevList) =>
      //   prevList.map((project) =>
      //     project.id == itemData.id ? { ...project, isHover: true } : project,
      //   ),
      // );
      item.isHover = true;
      return;
    }
    window.onClickGATrackEvent('home-project-hover-more');
    itemData.isOpen = true;
    setItemData(JSON.parse(JSON.stringify(itemData)));
  };
  useEffect(() => {
    if (itemData.isHover && !itemData.tempStatus) {
      itemData.isOpen = true;
      setItemData(JSON.parse(JSON.stringify(itemData)));
    }
  }, [itemData?.isHover, itemData?.tempStatus]);
  const handleDelete = async () => {
    console.log(itemData, 'itemData');

    window.onClickGATrackEvent('project-delete', {
      project_id: itemData.id,
    });
    if ((pageInfo.total - 1) / pageInfo.pageSize === pageInfo.pageIndex) {
      pageInfo.pageIndex = pageInfo.pageIndex - 1;
      setPageInfo({ ...pageInfo });
      console.log(pageInfo, 'pageInfo');
    }
    await projectController.delete({
      projectId: itemData.id,
    });
    setTimeout(() => {
      getList();
      setChildCallback(Date.now());
    });
  };

  const handleView = (item) => {
    window.onClickGATrackEvent('project-view', {
      project_id: item.id,
    });
    sessionStorage.setItem('projectItem', JSON.stringify(item));
    navigate('/view');
  };

  const handleEdit = (item) => {
    console.log('1232131');

    window.onClickGATrackEvent('project-edit', {
      project_id: item.id,
    });
    sessionStorage.setItem('projectItem', JSON.stringify(item));
    navigate('/edit');
  };

  const { t } = useTranslation();
  return (
    <div className="project_item">
      <div
        className="top"
        onMouseEnter={() => {
          window.onClickGATrackEvent('home-project-hover-cover');
        }}>
        <img className="project_img" src={itemData.thumbnail} alt="" />
        {/* 项目总时间 */}
        {[0, 2, 4, 6].includes(itemData.state) && (
          <>
            <div className="options_box">{formatMilliseconds(itemData.duration)}</div>
            <div
              className="options"
              onClick={() => {
                itemData.type === 0 ? handleView(itemData) : handleEdit(itemData);
              }}>
              {itemData.type === 0 && (
                <>
                  <section>
                    <Icon name="icon-view" className="icon_cut" />
                    <div className="text">{t('As_ProjectManage_PreviewView')}</div>
                  </section>
                  <i className="split-line"></i>
                </>
              )}
              <section>
                <Icon name="icon-edit_cut" className="icon_cut icon_edit" />
                {/*<div className="text">{t('As_ProjectManage_PreviewEdit')}</div>*/}
              </section>
            </div>
          </>
        )}
        {[1, 3, 5].includes(itemData.state) && (
          <div className="in-process">
            <div className="process_text">
              {getStateText(itemData.state, itemData.useHeygen)}
              <span className="spot_list process_spot">
                <span className="spot">·</span>
                <span className="spot">·</span>
                <span className="spot">·</span>
              </span>
            </div>
          </div>
        )}
        {itemData.state === 7 && (
          <div className="in-process failed">
            <Icon name="icon-info"></Icon>
            <div className="process_text">{t('As_Home_ProjectState4')}</div>
          </div>
        )}
        {itemData.state === 8 && (
          <div className="in-process failed">
            <div className="create_project_fail">{t('As_Edit_TranslateError')}</div>
          </div>
        )}
      </div>
      <div className="btm">
        <div className="project_information">
          <div className="project_name">
            {itemData.editShow ? (
              <input
                ref={inputRef}
                type="text"
                defaultValue={itemData.name}
                onChange={handleChangeName}
                onBlur={handleEditEnd}
                maxLength={200}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                placeholder=""
                className="input input-bordered w-full input-xs"
              />
            ) : (
              <div className="show_name">{itemData.name}</div>
            )}
          </div>
          <div className="last_time">
            {t('As_Home_ProjectTime1')} {timeDiffFromNow(itemData.gmtModified)}
          </div>
        </div>
        <div
          className={`dropdown dropdown-end dropdown-open lookList `}
          id={`dropdown-${itemData.id}`}
          onMouseEnter={() => mouseHoverShow()}
          onMouseLeave={() => mouseLeaveClose()}>
          <Icon
            tabIndex={0}
            name="icon-dot-more-vertically"
            className={`right_more ${itemData.tempStatus && 'disable_icon'}`}
          />
          {itemData.isOpen && (
            <>
              <div
                style={{
                  width: '180px',
                  height: '5px',
                  background: 'transparent',
                  marginLeft: '-140px',
                }}
              />
              <ul
                tabIndex={0}
                onMouseLeave={(e) => e.currentTarget.blur()}
                className="dropdown-content  bg-base-100 rounded-box z-[3] w-52 p-2 shadow homeCard_mean"
                style={{ position: 'absolute' }}>
                {itemData.type === 0 && (
                  <li>
                    <button
                      className="btn btn-ghost drop_item"
                      onClick={() => {
                        handleView(itemData);
                      }}>
                      <Icon name="icon-view" className="drop_icon" />
                      {t('As_ProjectManage_View')}
                    </button>
                  </li>
                )}
                <li>
                  <button
                    className="btn btn-ghost drop_item"
                    onClick={() => {
                      handleEdit(itemData);
                    }}
                    disabled={
                      [3, 5, 7, 8].includes(itemData.state) ||
                      (itemData.state === 1 && itemData.type > 0)
                    }>
                    <Icon name="icon-cut" className="drop_icon" />
                    {t('As_ProjectManage_Edit')}
                  </button>
                </li>
                <li>
                  <button
                    className="btn btn-ghost drop_item"
                    onClick={handleEditName}
                    disabled={[7].includes(itemData.state)}>
                    <Icon name="icon-edit" className="drop_icon" />
                    {t('As_ProjectManage_Rename')}
                  </button>
                </li>
                <li>
                  <button className="btn btn-ghost drop_item" onClick={handleDelete}>
                    <Icon name="icon-delete" className="drop_icon" />
                    {t('As_ProjectManage_Delete')}
                  </button>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// 空资源显示组件
function EmptyHome() {
  const { t } = useTranslation();
  return (
    <div className="empty_home">
      <img className="empty_img" src={HomeImg} alt="" />
      <div className="text">
        {t('As_Home_ProjectNull1334')}
        <br />
        {t('As_Home_ProjectNull2334')}
      </div>
    </div>
  );
}
